import React, { Component } from 'react';
import { Tabs, Tab } from 'react-bootstrap';

import { FontStyles } from './FontStyles';
import { BackgroundStyles } from './BackgroundStyles';
import { MarginStyles } from './MarginStyles';
import { CircleElementStyles } from './CircleElementStyles';
import { FontStyleCommand } from '../../commands/FontStyleCommand';
import { BackgroundStyleCommand } from '../../commands/BackgroundStyleCommand';
import { MarginStyleCommand } from '../../commands/MarginStyleCommand';
import { CircleElementStyleCommand } from '../../commands/CircleElementStyleCommand';

export class ComponentStyles extends Component {
    constructor(props) {
        super(props);

        this.state = {
            targetsFonts: {
                data: []
            },
            targetsBackgrounds: {
                data: []
            },
            targetsMargins: {
                data: []
            },
            targetsCircleElements: {
                data: []
            },
            actions: {
                isLoadingFontsTargets: true,
                isLoadingBackgroundsTargets: true,
                isLoadingMarginsTargets: true,
                isLoadingCircleElementsTargets: true
            }
        }

        this.getAvailableFontsTargets(false);
        this.getAvailableBackgroundsTargets(false);
        this.getAvailableMarginTargets(false);
        this.getAvailableCircleElementsTargets(false);
    }

    getAvailableFontsTargets(resetData) {
        if (resetData) {
            const { actions } = this.state;

            actions.isLoadingFontsTargets = true;

            this.setState({
                targetsFonts: {
                    data: []
                },
                actions: actions
            });
        }

        const fontStyleCommand = new FontStyleCommand();
        fontStyleCommand.getAvailableTargets(
            this.props.componentType,
            (a) => this.fontsTargetsSuccessCallback(a),
            (a) => this.errorCallback(a)
        );
    }

    getAvailableBackgroundsTargets(resetData) {
        if (resetData) {
            const { actions } = this.state;

            actions.isLoadingBackgroundsTargets = true;

            this.setState({
                targetsBackgrounds: {
                    data: []
                },
                actions: actions
            });
        }

        const backgroundStyleCommand = new BackgroundStyleCommand();
        backgroundStyleCommand.getAvailableTargets(
            this.props.componentType,
            (a) => this.backgroundsTargetsSuccessCallback(a),
            (a) => this.errorCallback(a)
        );
    }

    getAvailableMarginTargets(resetData) {
        if (resetData) {
            const { actions } = this.state;

            actions.isLoadingMarginsTargets = true;

            this.setState({
                targetsMargins: {
                    data: []
                },
                actions: actions
            });
        }

        const marginStyleCommand = new MarginStyleCommand();
        marginStyleCommand.getAvailableTargets(
            this.props.componentType,
            (a) => this.marginsTargetsSuccessCallback(a),
            (a) => this.errorCallback(a)
        );
    }

    getAvailableCircleElementsTargets(resetData) {
        if (resetData) {
            const { actions } = this.state;

            actions.isLoadingCircleElementsTargets = true;

            this.setState({
                targetsCircleElements: {
                    data: []
                },
                actions: actions
            });
        }

        const circleElementStyleCommand = new CircleElementStyleCommand();
        circleElementStyleCommand.getAvailableTargets(
            this.props.componentType,
            (a) => this.circleElementsTargetsSuccessCallback(a),
            (a) => this.errorCallback(a)
        );
    }

    // ---------------------------

    fontsTargetsSuccessCallback(result) {
        const { targetsFonts, actions } = this.state;

        targetsFonts.data = result;
        actions.isLoadingFontsTargets = false;

        this.setState({
            targetsFonts: targetsFonts,
            actions: actions
        });
    }

    backgroundsTargetsSuccessCallback(result) {
        const { targetsBackgrounds, actions } = this.state;

        targetsBackgrounds.data = result;
        actions.isLoadingBackgroundsTargets = false;

        this.setState({
            targetsBackgrounds: targetsBackgrounds,
            actions: actions
        });
    }

    marginsTargetsSuccessCallback(result) {
        const { targetsMargins, actions } = this.state;

        targetsMargins.data = result;
        actions.isLoadingMarginsTargets = false;

        this.setState({
            targetsMargins: targetsMargins,
            actions: actions
        });
    }

    circleElementsTargetsSuccessCallback(result) {
        const { targetsCircleElements, actions } = this.state;

        targetsCircleElements.data = result;
        actions.isLoadingCircleElementsTargets = false;

        this.setState({
            targetsCircleElements: targetsCircleElements,
            actions: actions
        });
    }

    errorCallback(message) {
        const { actions } = this.state;
        
        actions.isLoadingFontsTargets = false;
        actions.isLoadingBackgroundsTargets = false;
        actions.isLoadingCircleElementsTargets = false;

        this.setState({
            actions: actions,
            message: {
                show: true,
                message: message,
                style: "danger",
                title: "Erro",
                icon: "remove"
            }
        });
    }

    // ---------------------

    renderFontStyleTab(isLoadingTargets, targets, fonts) {
        if (0 === targets.data.length && !isLoadingTargets) {
            return null;
        }
        else {
            return (
                <Tab eventKey={1} title="Tipos de Letra" disabled={isLoadingTargets}>
                    <FontStyles
                        data={fonts}
                        targets={targets}
                        isLoadingTargets={isLoadingTargets}
                        onUpdateFonts={(a) => this.props.onUpdateStyles(a, "fonts")} />
                </Tab>
            );
        }
    }

    renderBackgroundStyleTab(isLoadingTargets, targets, backgrounds) {
        if (0 === targets.data.length && !isLoadingTargets) {
            return null;
        }
        else {
            return (
                <Tab eventKey={2} title="Fundos" disabled={isLoadingTargets}>
                    <BackgroundStyles
                        data={backgrounds}
                        targets={targets}
                        isLoadingTargets={isLoadingTargets}
                        onUpdateBackgrounds={(a) => this.props.onUpdateStyles(a, "backgrounds")} />
                </Tab>
            );
        }
    }

    renderMarginStyleTab(isLoadingTargets, targets, margins) {
        if (0 === targets.data.length && !isLoadingTargets) {
            return null;
        }
        else {
            return (
                <Tab eventKey={3} title="Margens" disabled={isLoadingTargets}>
                    <MarginStyles
                        data={margins}
                        targets={targets}
                        isLoadingTargets={isLoadingTargets}
                        onUpdateMargins={(a) => this.props.onUpdateStyles(a, "margins")} />
                </Tab>
            );
        }
    }

    renderCircleElementStyleTab(isLoadingTargets, targets, circleElements) {
        if (0 === targets.data.length && !isLoadingTargets) {
            return null;
        }
        else {
            return (
                <Tab eventKey={4} title="Círculos" disabled={isLoadingTargets}>
                    <CircleElementStyles
                        data={circleElements}
                        targets={targets}
                        isLoadingTargets={isLoadingTargets}
                        onUpdateCircleElements={(a) => this.props.onUpdateStyles(a, "circleElements")} />
                </Tab>
            );
        }
    }

    render() {
        const { fonts, backgrounds, margins, circleElements } = this.props;
        const { targetsFonts, targetsBackgrounds, targetsMargins, targetsCircleElements, actions } = this.state;

        const fontStyleTab = this.renderFontStyleTab(actions.isLoadingFontsTargets, targetsFonts, fonts);
        const backgroundStyleTab = this.renderBackgroundStyleTab(actions.isLoadingBackgroundsTargets, targetsBackgrounds, backgrounds);
        const marginStyleTab = this.renderMarginStyleTab(actions.isLoadingMarginsTargets, targetsMargins, margins);
        const circleElementStyleTab = this.renderCircleElementStyleTab(actions.isLoadingCircleElementsTargets, targetsCircleElements, circleElements);

        if (null === fontStyleTab && null === backgroundStyleTab && null === circleElementStyleTab) {
            return (
                <p>Não existem estilos que possam ser configurados para este tipo de elemento</p>
            )
        }

        return (
            <Tabs id="styles-tab">
                {fontStyleTab}
                {backgroundStyleTab}
                {marginStyleTab}
                {circleElementStyleTab}
            </Tabs>
        );
    }
}



// WEBPACK FOOTER //
// ./src/components/bussched/layoutConfigurations/componentStyles/ComponentStyles.js